import ApplicationController from 'javascript/controllers/application_controller';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends ApplicationController {
  showRepSales({ target: { value } }) {
    let urlParams = new URLSearchParams(this.window.location.search);
    let eventSlugString = urlParams.get('event_slug');

    if (urlParams.has('event_slug')) {
      Turbo.visit(`?event_slug=${eventSlugString}&rep_id=${value}`);
    } else {
      Turbo.visit(`?rep_id=${value}`);
    }
  }
}
